<!--  -->
<template>
	<div class="app" v-if="commentShow">
		<div class="comment-body">
			<div class="comment-body-release">
				<div class="comment-body-release-top">
					<p>
						本章评论
						<span>(共有{{comment.total}}条评论)</span>
						<a style="float: right;" target="_blank" href="https://jq.qq.com/?_wv=1027&k=566VJjw">
							<img width="120" border="0" src="data:image/jpeg;base64,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" alt="超自然调查小队" title="超自然调查小队" />
						</a>
					</p>

				</div>
				<div class="comment-body-release-body" v-if="show">
					<div class="comment-body-release-body-col1">
						<img :src="info.avatar?info.avatar:'../img/portrait.png'" alt />
					</div>
					<div class="comment-body-release-body-col2">
						<textarea v-model="content"></textarea>
					</div>
					<div class="comment-body-release-body-col3">
						<p v-if="length5">评论大于五个字</p>
						<div class="comment-body-release-body-col3-submit" @click="setComment">发布评论</div>
					</div>
				</div>
				<el-divider></el-divider>
				<!-- item -->
				<div class="comment-body-content" v-for="(item, index) in comment.data" :key="index">
					<div class="comment-body-content-left">
						<img :src="item.useravatar" alt v-if="item.useravatar" />
						<img src="../img/portrait.png" alt v-else />
					</div>
					<div class="comment-body-content-right">
						<!-- <div class="report" @click="toreport" style="cursor: pointer">举报</div> -->
						<div class="comment-body-content-right-col1">
							<div>{{item.username}}</div>
						</div>
						<div class="comment-body-content-right-col2">{{item.content}}</div>
						<div class="comment-body-content-right-col3">
							<p>{{item.create_time}}</p>
							<!-- <img src="../img/pl.png" alt />
							<div @click="showreply(item.id,item.content)">回复</div> -->
						</div>
						<el-divider v-if="comment.data.length>0"></el-divider>
						<!-- 子回复 -->
						<div v-if="item.child">
							<div
								class="comment-body-content-right-reply"
								v-for="(citem, Cindex) in item.child.data"
								:key="Cindex"
							>
								<div class="reply-left">
									<img :src="citem.useravatar" alt v-if="citem.useravatar" />
									<img src="../img/portrait.png" alt v-else />
								</div>
								<div class="reply-right">
									<div class="reply-right-col1">{{citem.username}}</div>
									<div class="reply-right-col2">{{citem.content}}</div>
									<div class="reply-right-col3">
										<p>{{citem.create_time}}</p>
										<img src="../img/pl.png" alt />
										<div style="margin-right:40px">回复</div>
										<!-- <div style="cursor: pointer">举报</div> -->
									</div>
								</div>
							</div>
							<div class="pagination" v-if="comment.data.length>0">
								<el-pagination
									small
									layout="pager"
									:total="item.child.total"
									:page-size="5"
									@current-change="Cpage"
								></el-pagination>
							</div>
						</div>
					</div>
				</div>
				<el-divider v-if="comment.total>5"></el-divider>
			</div>
			<div class="pagination" v-if="comment.total>5">
				<el-pagination
					small
					layout=" pager"
					:total="comment.total"
					:page-size="5"
					@current-change="Fpage"
				></el-pagination>
			</div>
			<!-- <div class="more-comment">
				<button>更多讨论</button>
			</div>-->
		</div>
		<publicmyhfmtk
			v-if="dialogTableVisible"
			@func="getMsgFormSon"
			:id="replyid"
			:replycomment="replycomment"
		></publicmyhfmtk>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';

	import publicmyhfmtk from "./publicmyhfmtk.vue";
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			publicmyhfmtk
		},
		props: ["comment", "reportid", "type"],
		data() {
			//这里存放数据
			return {
				dialogTableVisible: false,
				centerDialogVisible: false,
				content: "",
				reply: "",
				commentShow: true,
				Fpagenum: "",
				info: "",
				show: "",
				length5: ""
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			Fpage(page) {
				this.$parent.$parent.$parent.getCpage(page, 5, page, 5);
				this.Fpagenum = page;
			},
			Cpage(page) {
				this.$parent.$parent.$parent.getCpage(this.Fpagenum, 5, page, 5);
			},
			getMsgFormSon(data) {
				this.dialogTableVisible = data;
				this.$parent.$parent.$parent.getcomment();
			},
			getMsg(data) {
				this.centerDialogVisible = data;
			},
			// 回复
			setReply() {
				this.$http
					.post("comment/set/", {
						id: this.$route.query.id,
						reply: this.content
					})
					.then(res => {});
			},
			showreply(id, content) {
				this.dialogTableVisible = true;
				this.replyid = id;
				this.replycomment = content;
			},
			// 评论
			setComment() {
				if (this.content.length > 5) {
					this.length5 = false;
					this.$http
						.post("comment/setone", {
							id: this.$route.query.id,
							type: this.type,
							content: this.content,
							token: this.$cookies.get("token")
						})
						.then(res => {
							this.$parent.$parent.$parent.getcomment();
							this.$router.go(0);
						});
				} else {
					this.length5 = true;
				}
			},
			toreport() {
				this.$http
					.post("user/report/", {
						id: this.reportid,
						token: this.$cookies.get("token")
					})
					.then(res => {
						if (res.body.code == 1) {
							this.$notify({
								message: "举报成功",
								type: "success"
							});
						}
					});
			},
			getinfo() {
				this.$http
					.post("user/info", {
						token: this.$cookies.get("token")
					})
					.then(res => {
						if (res.body.code == 1) {
							this.info = res.body.data;
						}
					});
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.getinfo();
			if (this.$cookies.isKey("token")) {
				this.show = true;
				console.log("show", this.show);
			} else {
				this.show = false;
			}
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
		},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style  scoped>
	.works-xxk-mydiv {
		display: flex;
	}
	.works-xxl-foot {
		height: 160px;
		box-sizing: border-box;
		border: 1px solid #cccccc;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.works-xxl-foot-div {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.works-xxl-foot-div-img {
		width: 44px;
		height: 44px;
		margin: 0 auto;
	}
	.comment-body-release-top {
		margin-top: 30px;
	}
	.comment-body-release-top > p {
		font-size: 16px;
	}
	.comment-body-release-top > p > span {
		font-size: 12px;
	}
	.comment-body-release-body {
		display: flex;
		flex-direction: row;
		margin: 30px 0;
		position: relative;
	}
	.comment-body-release-body-col1 img {
		height: 60px;
		width: 60px;
		border-radius: 50%;
		margin: 0 10px;
	}
	.comment-body-release-body-col2 textarea {
		width: 680px;
		height: 140px;
		border: 1px solid rgba(204, 204, 204, 1);
		border-radius: 8px;
		font-size: 12px;
		padding: 11px;
		background-color: #f5f5f5;
		resize: none;
	}
	.comment-body-release-body-col3 {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-content: flex-end;
		position: absolute;
		bottom: 0;
		right: 20px;
	}
	.comment-body-release-body-col3 > p {
		font-size: 12px;
		color: rgba(204, 41, 41, 1);
		margin-bottom: 20px;
	}
	.comment-body-release-body-col3-submit {
		width: 80px;
		height: 32px;
		background: rgba(40, 163, 177, 1);
		border-radius: 4px;
		line-height: 32px;
		text-align: center;
		font-size: 12px;
		color: rgba(255, 255, 255, 1);
		margin-bottom: 11px;
		cursor: pointer;
	}
	.comment-body-content-right {
		width: 800px;
	}
	.comment-body-content {
		display: flex;
		flex-direction: row;
		position: relative;
		padding: 20px 0;
	}
	.comment-body-content-right .report {
		position: absolute;
		top: 20px;
		right: 30px;
		font-size: 12px;
	}
	.comment-body-content-left img {
		height: 60px;
		width: 60px;
		border-radius: 50%;
		margin: 0 10px;
	}
	.comment-body-content-right-col1 {
		font-size: 12px;
		font-weight: bold;
	}
	.comment-body-content-right-col1 {
		font-size: 12px;
		font-weight: bold;
	}
	.comment-body-content-right-col2 {
		font-size: 16px;
		line-height: 26px;
		margin: 20px 40px 42px 0;
	}
	.comment-body-content-right-col3 {
		display: flex;
		flex-direction: row;
	}

	.comment-body-content-right-col3 img {
		width: 16px;
		height: 14px;
		margin: 0 8px 0 18px;
	}
	.comment-body-content-right-col3 div {
		color: #28a3b1;
		font-size: 12px;
		cursor: pointer;
	}

	.comment-body-content-right-reply {
		display: flex;
		flex-direction: row;
	}
	.reply-left img {
		height: 40px;
		width: 40px;
		border-radius: 50%;
	}
	.reply-right {
		display: flex;
		flex-direction: column;
		margin: 0 10px 30px;
	}
	.reply-right-col1 {
		font-size: 12px;
		font-weight: bold;
	}
	.reply-right-col2 {
		font-size: 12px;
		font-weight: bold;
		margin: 12px 0 30px;
		font-size: 12px;
	}
	.reply-right-col3 {
		display: flex;
		flex-direction: row;
		font-size: 12px;
	}
	p {
		font-size: 12px;
	}
	.reply-right-col3 img {
		height: 14px;
		width: 16px;
		margin: 0 8px 0 8px;
	}
	.reply-right-col3 div:nth-child(1) {
		margin-right: 40px;
		color: #28a3b1;
	}
	.pagination {
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.more-comment {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
	.more-comment button {
		width: 120px;
		height: 44px;
		background: rgba(40, 163, 177, 1);
		border-radius: 8px;
		color: #ffffff;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 0;
	}
</style>
<style >
	.el-pager,
	.el-pager li {
		background-color: #f5f5f5;
	}
</style>



// WEBPACK FOOTER //
// src/components/Comment.vue